/**
 * 将生成的图片添加到tldraw画布
 * @param {Editor} editor - tldraw编辑器实例
 * @param {string} imageUrl - 图片URL
 * @param {string} prompt - 生图提示词
 */
export async function addImageToCanvas(editor, imageUrl, prompt) {
  try {
    // 获取画布中心位置
    const viewportCenter = editor.getViewportPageBounds().center
    
    // 创建资源ID
    const assetId = editor.createAssetId()
    
    // 加载图片获取尺寸
    const img = new Image()
    img.crossOrigin = 'anonymous'
    
    await new Promise((resolve, reject) => {
      img.onload = resolve
      img.onerror = reject
      img.src = imageUrl
    })
    
    const width = img.width
    const height = img.height
    
    // 计算合适的显示尺寸（最大800px）
    const maxSize = 800
    let displayWidth = width
    let displayHeight = height
    
    if (width > maxSize || height > maxSize) {
      const ratio = Math.min(maxSize / width, maxSize / height)
      displayWidth = width * ratio
      displayHeight = height * ratio
    }
    
    // 创建图片资源
    editor.createAssets([
      {
        id: assetId,
        type: 'image',
        typeName: 'asset',
        props: {
          name: prompt || '生成的图片',
          src: imageUrl,
          w: width,
          h: height,
          mimeType: 'image/png',
          isAnimated: false
        },
        meta: {
          prompt: prompt
        }
      }
    ])
    
    // 在画布中心创建图片形状
    const shapeId = editor.createShapeId()
    editor.createShape({
      id: shapeId,
      type: 'image',
      x: viewportCenter.x - displayWidth / 2,
      y: viewportCenter.y - displayHeight / 2,
      props: {
        assetId: assetId,
        w: displayWidth,
        h: displayHeight
      }
    })
    
    // 选中新创建的图片
    editor.select(shapeId)
    
    console.log('图片已添加到画布:', { assetId, shapeId, width, height })
    
    return shapeId
  } catch (error) {
    console.error('添加图片到画布失败:', error)
    throw error
  }
}

/**
 * 导出画布为图片
 * @param {Editor} editor - tldraw编辑器实例
 */
export async function exportCanvas(editor) {
  try {
    const svg = await editor.getSvgString(editor.getCurrentPageShapeIds())
    return svg
  } catch (error) {
    console.error('导出画布失败:', error)
    throw error
  }
}
